import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import { Plus, Pencil, Trash2, Copy, Share2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", code: "", commission_percent: 10, discount_percent: 0, active: true };

export default function AdminAffiliates() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const load = () => api.get("/admin/affiliates").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (edit.id) await api.put(`/admin/affiliates/${edit.id}`, edit);
      else await api.post("/admin/affiliates", edit);
      toast.success("Запазено"); setEdit(null); load();
    } catch { toast.error("Грешка"); }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/affiliates/${id}`); load(); } };
  const copyLink = (code) => { navigator.clipboard.writeText(`${base}/?ref=${code}`); toast.success("Линкът е копиран"); };

  return (
    <div data-testid="admin-affiliates">
      <PageHead title="Афилиейт линкове" desc="Партньорски линкове с комисионна. Когато клиент дойде през линк и купи, партньорът получава комисионна, а може да предложите и отстъпка."
        action={<button onClick={() => setEdit({ ...EMPTY })} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="add-affiliate-btn"><Plus size={16} /> Нов партньор</button>} />
      <div className="bg-white border border-stone overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-stone text-navy"><tr><th className="text-left p-3">Партньор</th><th className="text-left p-3">Линк</th><th className="text-left p-3">Комисионна</th><th className="text-left p-3">Отстъпка</th><th className="text-left p-3">Клика</th><th className="text-left p-3">Поръчки</th><th className="text-left p-3">Печалба</th><th className="p-3"></th></tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-stone" data-testid={`affiliate-${a.code}`}>
                <td className="p-3 text-navy font-medium flex items-center gap-2"><Share2 size={14} className="text-gold" />{a.name}</td>
                <td className="p-3"><button onClick={() => copyLink(a.code)} className="flex items-center gap-1 text-gold hover:underline font-mono text-xs"><Copy size={12} /> ?ref={a.code}</button></td>
                <td className="p-3">{a.commission_percent}%</td>
                <td className="p-3">{a.discount_percent}%</td>
                <td className="p-3">{a.clicks || 0}</td>
                <td className="p-3">{a.orders_count || 0}</td>
                <td className="p-3 text-navy font-medium">{(a.earnings || 0).toFixed(2)} €</td>
                <td className="p-3 text-right"><div className="flex justify-end gap-2"><button onClick={() => setEdit(a)} className="text-navy hover:text-gold"><Pencil size={15} /></button><button onClick={() => del(a.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={15} /></button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <Modal title={edit.id ? "Редакция" : "Нов партньор"} onClose={() => setEdit(null)}>
          <form onSubmit={save}>
            <Field label="Име на партньор"><input required value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} className={inp} data-testid="affiliate-name" /></Field>
            <Field label="Код" hint="Остави празно за автоматичен"><input value={edit.code} onChange={(e) => setEdit({ ...edit, code: e.target.value.toUpperCase() })} className={inp} placeholder="PARTNER10" /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Комисионна %"><input type="number" value={edit.commission_percent} onChange={(e) => setEdit({ ...edit, commission_percent: e.target.value })} className={inp} data-testid="affiliate-commission" /></Field>
              <Field label="Отстъпка за клиент %"><input type="number" value={edit.discount_percent} onChange={(e) => setEdit({ ...edit, discount_percent: e.target.value })} className={inp} /></Field>
            </div>
            <label className="flex items-center gap-2 text-sm text-navy mb-3"><input type="checkbox" checked={edit.active} onChange={(e) => setEdit({ ...edit, active: e.target.checked })} className="accent-[#C6A45C]" /> Активен</label>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm" data-testid="save-affiliate-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
